export default {
  logo: require('@/assets/admin/images/atlas-logo.png'),
  print_logo: require('@/assets/admin/images/print-logo.png'),
  print_font: require('@/assets/fonts/Yekan_bakh/Yekan-Bakh-Medium.woff'),
  product: {
    hasVariety: true,
    hasColor: true,
    hasSizeChart: true,
    hasNewsletters: true,
    hasSets: true,
    hasFlash: true,
    hasShortDescription: false,
    showSkuAndBarcode: true,
    excelType1: true
  },
  customer: {
    hasRole: true,
  },
  sizeChart: {
    changeColumn: false, // کم و زیاد کردن ستون ها
    hasType: true // آیا سایز چارت تایپ دارد یا نه
  },
  hasInstagram: true,
  withdraw: {
    active: true
  },
  physicalShop: {
    active: true,
    hasSellers: true,
    printPrice: 'rial'
  }
}
